import type { NotificationResultCondition } from '@prisma/client';

export type FormValueTypes = {
  channel: string;
  testRunStarts: boolean;
  testRunFinishes: boolean;
  weeklySummary: boolean;
  dailySummary: boolean;
  endType: NotificationResultCondition;
  disableOverride: boolean;
};
// Helper function to retrieve config values
export const getNotificationConfigValues = (
  config:
    | {
        testSuiteRunStart: boolean;
        testSuiteRunEnd: NotificationResultCondition;
        weeklySummary: boolean;
        dailySummary: boolean;
      }
    | undefined
    | null,
  props: Record<string, unknown> = {},
): FormValueTypes => {
  return {
    channel: '',
    testRunStarts: config?.testSuiteRunStart ?? false,
    testRunFinishes: (config?.testSuiteRunEnd ?? 'NONE') !== 'NONE',
    weeklySummary: config?.weeklySummary ?? false,
    dailySummary: config?.dailySummary ?? false,
    endType: config?.testSuiteRunEnd ?? 'NONE',
    disableOverride: false,
    ...props,
  };
};
